<h2 mat-dialog-title>Activar formación</h2>

<mat-dialog-content>
  <p>
    Empleado: <strong>{{ user_full_name }}</strong>
  </p>

  @if (initializing()) {
    <p class="loading-hint">Cargando formaciones…</p>
  } @else if (learning_resources().length === 0) {
    <p class="warning-hint">
      No hay formaciones disponibles para activar. No se muestran los cursos ya completados ni los que ya tiene activos.
    </p>
  } @else {
    <form [formGroup]="form">
      <mat-form-field class="w-100">
        <mat-label>Formación</mat-label>
        <mat-select formControlName="learning_resource_id">
          @for (learning_resource of learning_resources(); track learning_resource.id) {
            <mat-option [value]="learning_resource.id">{{ learning_resource.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </form>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="close()" [disabled]="loading()">Cancelar</button>
  <button
    mat-flat-button
    color="accent"
    type="button"
    (click)="activate()"
    [disabled]="loading() || initializing() || form.invalid || learning_resources().length === 0"
  >
    Activar
  </button>
</mat-dialog-actions>
